import React from 'react';
import {
  GalleryGrid,
  TemplateCardListItems as LibraryTemplateCardListItems,
} from '@wix/wix-studio-marketplace-lib';
import { TemplateListCardComponentProps } from '@wix/wix-studio-marketplace-lib/dist/types/components/TemplateGallery/TemplateCardListItems/TemplateCardListItems';
import { TemplateGalleryCard } from '@common/types';
import TemplateCardListItems from '@components/Templates/TemplateGallery/TemplateCardListItems';
import TemplateCardAdaptive from '@components/Templates/TemplateGallery/TemplateCard/TemplateCardAdaptive';
import TemplatesLoadingState from '@components/Profile_New/ProfileTemplates/TemplatesLoadingState';
import WrappedTemplateCard from '@components/Profile_New/ProfileTemplates/WrappedTemplateCard';
import { mapTemplatesToLibraryFormat } from '@utils/profileTemplatesUtils';
import s from './ProfileTemplates.module.scss';
import clsx from 'clsx';
interface RenderGalleryProps {
  templates: TemplateGalleryCard[];
  isMobileView: boolean;
  logTemplateClick: (templateId?: string, action?: string) => void;
  shouldShowThreeInRow?: boolean;
}

const RenderGallery: React.FC<RenderGalleryProps> = ({
  templates,
  isMobileView,
  logTemplateClick,
  shouldShowThreeInRow = false,
}) => {
  const wrappedTemplateCardWithProps = (
    props: TemplateListCardComponentProps,
  ) => {
    return (
      <WrappedTemplateCard
        {...props}
        logTemplateClick={logTemplateClick}
        isMobileView={isMobileView}
      />
    );
  };

  if (isMobileView) {
    return (
      <div className={s.gridContainer}>
        <ul className={`${s.content} ${s.mobileView}`}>
          <TemplateCardListItems
            CardComponent={(props) => (
              <TemplateCardAdaptive
                {...props}
                isMobileView={true}
                showShadow={false}
                onCustomClick={() =>
                  logTemplateClick(props.template.id || '', 'go to template')
                }
              />
            )}
            LoadingState={() => <TemplatesLoadingState isMobileView={true} />}
            templates={templates}
            isMobileView={true}
            SSRFlow={false}
          />
        </ul>
      </div>
    );
  }

  const mappedTemplates = mapTemplatesToLibraryFormat(templates);
  return (
    <GalleryGrid
      listGridClassOverride={clsx(
        s.galleryGridList,
        shouldShowThreeInRow && s.threeInRow,
      )}
      content={
        <LibraryTemplateCardListItems
          CardComponent={wrappedTemplateCardWithProps}
          LoadingState={() => <TemplatesLoadingState isMobileView={false} />}
          templates={mappedTemplates}
          isMobileView={isMobileView}
          SSRFlow={false}
        />
      }
    />
  );
};

export default RenderGallery;
